import AgreementMasterPage from './AgreementMasterPage';

export default AgreementMasterPage;
